import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as RadioOffIcon } from '../../assets/images/svg/radio-off.svg';
import themeColors from '../../assets/styles/themeColors';

const RadioOffIconStyled = styled(RadioOffIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const RadioOff = (props) => <RadioOffIconStyled {...props} />;

RadioOff.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

RadioOff.defaultProps = {
  w: '21px',
  h: '21px',
};

export default RadioOff;
